<template>
  <div class="book-reader">
    <Header />
    <CopyrightWarning />
    
    <div class="back-content" @click="voltar" title="Voltar">
      <i class="fa-solid fa-arrow-left"></i>
    </div>

    <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="800px" frameborder="0"></iframe>

    <div class="text" v-else-if="book.hash">
      Carregando livro...
    </div>

    <div v-else class="mensagem">
      Livro não encontrado.
    </div>

    <BookModal v-if="showModal" :book="book" @close="showModal = false" />
    <Watermark />
  </div>
</template>

<style scoped src="../styles/Book.css"/>

<script>
import request, { Url } from '../router/request'
import Header from '@/components/Header.vue'
import BookModal from '@/components/BookModal.vue'
import { antiPiracyMixin } from '@/mixins/antiPiracyMixin'
import Watermark from '@/components/Watermark.vue'
import CopyrightWarning from '@/components/CopyrightWarning.vue'

export default {
  name: 'BookView',
  mixins: [antiPiracyMixin],
  components: {
    Header,
    BookModal,
    Watermark,
    CopyrightWarning
  },
  data() {
    return {
      pdfUrl: '',
      showModal: false,
      book: {
        amd: this.$route.query.amd,
        hash: this.$route.query.hash
      }
    }
  },
  methods: {
    voltar() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    },
    viewBook() {
      const { amd, hash } = this.book;

      if (!amd || !hash) {
        alert('Parâmetros ausentes para carregar o PDF.');
        return;
      }

      console.log('Preparando PDF com:', { amd, hash });

      request.post('/arquivo/prepararDownload', {
        ano_mes_dia_arq: amd,
        hash_arquivo: hash
      })
        .then(response => {
          console.log('Resposta prepararDownload:', response.data);
          if (response.data && response.data.hash) {
            this.pdfUrl = `${Url}/arquivo/download?hash=${response.data.hash}#toolbar=0&navpanes=0`;
          } else {
            alert('Erro: o PDF não foi preparado corretamente.');
          }
        })
        .catch(error => {
          console.error('Erro ao preparar o PDF:', error);
          alert('Erro ao preparar o PDF. Verifique os dados ou tente novamente.');
        });
    }
  },
  mounted() {
    console.log('URL da API:', Url);
    window.scrollTo(0, 0);
    this.viewBook();
  }
}
</script>
